import React from 'react'

const DashboardHeader = ({ label }) => {
  return (
    <h1 className="text-2xl font-bold text-black dark:text-white">{label}</h1>
  )
}

export default DashboardHeader